import config from '../config';
import axios from 'axios';
import router from '../Routes';
import * as firebase from 'firebase';
import { firebaseApp, firestore } from '../main';

export default {
  namespaced: true,

  state: {
    currentUser: null,
    isFetching: false,
    errorMessage: ''
  },
  getters: {
    getCurrentUser(state) {
      return state.currentUser;
    }
  },
  mutations: {
    LOGIN_FAILURE(state, payload) {
      state.isFetching = false;
      state.errorMessage = payload;
    },
    LOGIN_SUCCESS(state, payload) {
      state.currentUser = payload;
      state.isFetching = false;
      state.errorMessage = '';
    },
    LOGIN_REQUEST(state) {
      state.isFetching = true;
    },
    LOGOUT_USER(state) {
      state.currentUser = {};
    },
    RECEIVED_CURRENT_USER(state, payload) {
      state.currentUser = payload;
    },
    CHANGE_SELECTED_TENANT(state, payload) {
      state.currentUser.selectedCountryId = payload;
    }
  },
  actions: {
    async fetchCurrentUser({ dispatch }) {
      const userEmail = localStorage.getItem('userEmail');
      const currentUserRef = await firestore
        .collection('users')
        .where('email', '==', userEmail)
        .get();
      if (currentUserRef.docs.length > 0) {
        let currentUserData = currentUserRef.docs[0].data();
        currentUserData.id = currentUserRef.docs[0].id;
        localStorage.setItem('user', JSON.stringify(currentUserData));

        await dispatch('receiveCurrentUserData', currentUserData);
      }
    },
    loginUser({ dispatch }, creds) {
      dispatch('requestLogin');
      if (creds.username.length > 0 && creds.password.length > 0) {
        // axios.defaults.baseURL = config.authURLApi;
        const headers = {
          'Content-Type': 'application/json',
          'Client-ID': config.StarchaserClientID
        };
        axios
          .post(`${config.authURLApi}/authenticate-web`, creds, { headers: headers })
          .then(async res => {
            // axios.post(`api/authenticate-web`, creds, {headers: headers}).then( async res => {
            const serverToken = res.data.serverToken;
            const firebaseCustomToken = res.data.firebaseToken;

            const authHeaders = Object.assign({}, headers, { Authorization: `Bearer ${serverToken}` });
            const accountDetails = await axios.get(`${config.authURLApi}/account-details`, { headers: authHeaders });
            // const accountDetails = await axios.get('api/account-details', {headers: authHeaders});
            const accountDetailsData = accountDetails.data;

            firebase
              .auth()
              .signInWithCustomToken(firebaseCustomToken)
              .then(async response => {
                const x = await firebaseApp.auth().currentUser.getIdToken(/* forceRefresh */ true);
                console.log('ICS', x);
                const userTenant = await firestore
                  .collection('countries')
                  .where('adCode', '==', accountDetailsData.tenantCode)
                  .get();
                const tenantId = userTenant.docs.length > 0 ? userTenant.docs[0].id : null;
                if (tenantId != null) {
                  const dbUser = await firestore
                    .collection('users')
                    .where('email', '==', creds.username)
                    .get();
                  const userRef = dbUser.docs.length > 0 ? dbUser.docs[0].ref : firestore.collection('users').doc();
                  await userRef.set(
                    {
                      email: accountDetailsData.email,
                      firstName: accountDetailsData.firstName,
                      lastName: accountDetailsData.lastName,
                      department: accountDetailsData.department,
                      jobTitle: accountDetailsData.jobTitle,
                      tenantId: tenantId,
                      userAuthorities: accountDetailsData.userAuthorities,
                      active: true
                    },
                    { merge: true }
                  );
                } else {
                  dispatch('loginError', 'Your tenant was not configured');
                }

                dispatch('receiveTokens', { user: response.user, serverToken: serverToken });
              })
              .catch(function(error) {
                dispatch('loginError', error.response.data);
              });
          })
          .catch(err => {
            dispatch('loginError', err.response.data);
          });

        // firebase.auth().signInWithEmailAndPassword(creds.email, creds.password).then(
        //   async user => {
        //     console.log('Signed in user', user);
        //     dispatch('receiveToken', user);
        //     firebaseApp.auth().onAuthStateChanged(function(user) {
        //       if (user) {
        //         user.getIdToken(true).then(function(idToken) {
        //           axios.defaults.headers.common['Authorization'] = "Bearer " + idToken;
        //
        //         }).catch(function(error) {
        //           console.log("ERROR", error)
        //         });
        //       } else {
        //         //payload.$toasted.success("Relogin, please!");
        //       }
        //     });
        //   },
        //   err => {
        //     dispatch('loginError', err);
        //   }
        // );
      } else {
        dispatch('loginError', 'Something was wrong. Try again');
      }
    },
    async receiveTokens({ dispatch }, loginResponse) {
      const token = loginResponse.user.ma;
      const userEmail = loginResponse.user.uid;
      const currentUserRef = await firestore
        .collection('users')
        .where('email', '==', userEmail)
        .get();
      if (currentUserRef.docs.length > 0) {
        let currentUserData = currentUserRef.docs[0].data();
        currentUserData.id = currentUserRef.docs[0].id;
        console.log('TOKEN', token);
        console.log('USER RESPONSE', loginResponse.user);

        localStorage.setItem('token', token);
        localStorage.setItem('serverToken', loginResponse.serverToken);
        localStorage.setItem('firebaseToken', loginResponse.firebaseToken);
        localStorage.setItem('userEmail', userEmail);
        localStorage.setItem('user', JSON.stringify(currentUserData));
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
        dispatch('receiveLogin', currentUserData);
      }
    },
    logoutUser({ commit }) {
      firebase
        .auth()
        .signOut()
        .then(function() {
          localStorage.removeItem('token');
          localStorage.removeItem('user');
          document.cookie = 'token=;expires=Thu, 01 Jan 1970 00:00:01 GMT;';
          axios.defaults.headers.common['Authorization'] = '';
          commit('LOGOUT_USER');
          router.push('/login');
        })
        .catch(function(error) {
          console.log('Error on logout', error);
        });
    },
    async receiveCurrentUserData({ commit }, payload) {
      await commit('RECEIVED_CURRENT_USER', payload);
    },
    loginError({ commit }, payload) {
      commit('LOGIN_FAILURE', payload);
    },
    receiveLogin({ commit }, payload) {
      commit('LOGIN_SUCCESS', payload);
      router.push('/app/content/behaviours');
    },
    requestLogin({ commit }) {
      commit('LOGIN_REQUEST');
    },
    changeSelectedTenantIdForCurrentUser({ commit }, tenantId) {
      commit('CHANGE_SELECTED_TENANT', tenantId);
    }
  }
};
